<template>
  <div style="width: 40%" class="editable-div">
    <InlineEditor toolbar="" v-model="myValue" :show-input="showBlank" plaintext />
  </div>
</template>

<script>
import InlineEditor from '@/components/Tinymce/inline-editor'
export default {
  name: 'editable-div',
  components: {InlineEditor},
  props: {
    value: {
      type: String,
      default: ''
    },
    showBlank: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    myValue(val) {
      this.$emit('input', val)
    }
  },
  data() {
    return {
      myValue: this.value
    }
  }
}
</script>

<style scoped lang="scss">
.edit-div:focus {
  border-color: #909399;
  background-color: #F2F6FC;
}
.edit-div {
  width: 70%;
  border: 1px dashed transparent;
}
.edit-div:hover{
  border-color: #909399;
}
.show-blank:after {
  content: '';
  margin-left: 8px;
  width: 70px;
  height: 20px;
  display: block;
  border: 1px solid #d8d8d8;
}
</style>



// WEBPACK FOOTER //
// src/components/editable-div/index.vue